// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./public/less/chat.less
// module id = 587
// module chunks = 0